module.exports = {
    textAddLang: {
        svg: {
            width: '19',
            height: '19',
            viewBox: '0 0 19 19'
        },
        content: '<path fill-rule=\"evenodd\" d=\"M16.123 13.62l.335-.334-2.021-2.283a4.96 4.96 0 0 0 .915-2.869 5 5 0 0 0-5-5A4.955 4.955 0 0 0 7.34 4.167L5.161 2l-.358.319A7.933 7.933 0 0 0 2.458 7.97c0 2.134.833 4.141 2.345 5.65A7.936 7.936 0 0 0 10 15.939V18H8v1h5v-1h-2v-2.065a7.939 7.939 0 0 0 5.123-2.315zM3.466 7.97c0-1.696.602-3.3 1.704-4.568l1.437 1.451a4.956 4.956 0 0 0-1.255 3.281 5 5 0 0 0 5 5 4.97 4.97 0 0 0 3.416-1.366l1.296 1.464a6.953 6.953 0 0 1-4.602 1.723 6.956 6.956 0 0 1-4.946-2.046 6.934 6.934 0 0 1-2.05-4.939zm10.923.164a4.04 4.04 0 0 1-4.037 4.036 4.04 4.04 0 0 1-4.036-4.036 4.04 4.04 0 0 1 4.036-4.036 4.04 4.04 0 0 1 4.037 4.036z\" ></path>'
    },
    textAlignBlock: {
        svg: {
            width: '20',
            height: '22',
            viewBox: '0 0 20 22'
        },
        content: '<path d=\"M4 3h13v2H4zM4 15h13v2H4zM4 6h13v2H4zM4 12h13v2H4zM4 9h13v2H4z\" ></path>'
    },
    textAlignCenter: {
        svg: {
            width: '20',
            height: '22',
            viewBox: '0 0 20 22'
        },
        content: '<path d=\"M3 3h14v2H3zM3 15h14v2H3zM6 6h8v2H6zM6 12h8v2H6zM4 9h12v2H4z\" ></path>'
    },
    textAlignLeft: {
        svg: {
            width: '20',
            height: '22',
            viewBox: '0 0 20 22'
        },
        content: '<path d=\"M4 3h14v2H4zM4 15h14v2H4zM4 6h9v2H4zM4 12h9v2H4zM4 9h13v2H4z\" ></path>'
    },
    textAlignRight: {
        svg: {
            width: '20',
            height: '22',
            viewBox: '0 0 20 22'
        },
        content: '<path d=\"M4 3h14v2H4zM4 15h14v2H4zM8 6h10v2H8zM8 12h10v2H8zM5 9h13v2H5z\" ></path>'
    },
    textBold: {
        svg: {
            width: '11',
            height: '14',
            viewBox: '0 0 11 14'
        },
        content: '<path fill-rule=\"evenodd\" d=\"M6.74 14H1.98c-1.09 0-1.99-.9-1.99-2V2c0-1.1.9-2 1.99-2h3.9C7.34 0 8.5.64 9.25 1.79c.81 1.24.87 2.83.16 4.15-.14.27-.15.51-.35.73 1 .65 1.71 1.7 1.83 2.9.11 1.15-.24 2.24-.98 3.07C9.13 13.5 7.97 14 6.74 14zM1.98 8v4h4.98c.67 0 2 .06 2-2 0-1.94-.9-2-2-2H1.98zm0-2h3.99c.62 0 1.99 0 1.99-2 0-1.94-1.21-2-1.99-2H1.98v4z\" ></path>'
    },
    textCharSpacing: {
        svg: {
            width: '18',
            height: '16',
            viewBox: '0 0 18 16'
        },
        content: '<path fill-rule=\"evenodd\" d=\"M15.53 7.96L14.62 9h-.93l-1.07-1.08L9.54 0h2.08l2.42 7 2.58-7h1.92l-3.01 7.96zM7.46 9l-1-2h-3l-1 2H.54l3-7.96L4.46 0h.92l1.08 1.08L9.54 9H7.46zM5.04 2L3.96 5h2l-.92-3zm-.58 10h10v-2l4 3-4 3v-2h-10v2l-4-3 4-3v2z\" ></path>'
    },
    textEffectsIndicator: {
        svg: {
            width: '15',
            height: '12',
            viewBox: '0 0 15 12'
        },
        content: '<path fill-rule=\"evenodd\" d=\"M13.99 5.39c-.14.17-.32.26-.54.26-.13 0-.24-.03-.31-.08a.656.656 0 0 1-.18-.19c-.04-.07-.08-.14-.12-.19-.04-.06-.1-.08-.17-.08-.11 0-.24.09-.39.27-.16.19-.34.47-.53.86l.13.91c.08.41.16.69.27.84.1.16.22.24.36.24.17 0 .28-.08.33-.25.04-.17.06-.38.06-.64 0-.02.03-.04.08-.06.05-.01.09-.02.11-.02.05 0 .1.01.16.02.05.02.08.04.09.06.02.04.03.09.06.16.02.08.03.17.03.28 0 .4-.16.73-.48.97-.32.25-.67.37-1.06.37-.35 0-.66-.14-.94-.42-.28-.28-.48-.69-.61-1.23-.29.57-.54.98-.76 1.25-.21.27-.5.4-.87.4-.22 0-.43-.07-.64-.22-.21-.14-.32-.36-.32-.64 0-.24.08-.45.23-.62.15-.17.35-.26.6-.26.2 0 .35.08.45.22.09.15.21.22.34.22.1 0 .21-.07.34-.23.13-.15.29-.4.47-.75L10 5.82c-.07-.36-.15-.63-.24-.8-.1-.17-.21-.25-.32-.25-.18 0-.28.08-.31.25-.03.17-.05.38-.05.63 0 .02-.02.04-.07.05-.05.02-.09.02-.11.02-.06 0-.11 0-.16-.02a.187.187 0 0 1-.1-.05.854.854 0 0 1-.06-.19c-.01-.08-.02-.17-.02-.25 0-.39.14-.71.42-.97.28-.25.62-.38 1-.38.37 0 .71.16 1.02.46.3.3.5.73.58 1.27.3-.6.58-1.04.83-1.31.25-.28.52-.42.81-.42.3 0 .54.09.72.26.18.17.27.39.27.66 0 .23-.07.43-.22.61zM9.46 2.92c-.22 0-.37-.06-.47-.19-.1-.13-.18-.27-.25-.43-.06-.17-.14-.31-.21-.44-.08-.14-.2-.2-.37-.2-.35 0-.62.18-.79.53-.18.36-.39 1.05-.62 2.08h1.19c.04 0 .07.03.08.09.01.06.02.12.02.17 0 .08-.02.16-.06.26-.04.09-.08.14-.13.14l-1.24-.04-.9 3.79c-.27 1.09-.69 1.92-1.27 2.47-.59.55-1.28.83-2.09.83-.46 0-.87-.12-1.22-.38-.35-.25-.53-.54-.54-.86 0-.24.09-.44.26-.61.16-.17.39-.25.68-.25.24 0 .43.08.57.23.15.15.26.3.35.46.09.16.18.32.28.47.09.14.21.22.34.22.17-.01.3-.13.4-.36.11-.23.2-.56.27-.97l1.05-4.92c.01-.03.01-.06-.01-.08-.01-.03-.04-.04-.1-.04H3.8c-.02 0-.05-.03-.07-.09-.02-.07-.02-.11-.02-.13 0-.03.01-.08.04-.13.03-.06.06-.08.09-.08.45-.06.76-.12.92-.17.16-.06.25-.12.26-.18.24-.87.71-1.63 1.39-2.29.69-.66 1.5-.99 2.43-.99.38 0 .73.12 1.04.37.3.25.46.51.46.8 0 .26-.08.47-.24.65-.17.18-.38.27-.64.27z\" ></path>'
    },
    textIndentLeft: {
        svg: {
            width: '20',
            height: '22',
            viewBox: '0 0 20 22'
        },
        content: '<path d=\"M4 3h13v2H4zM4 15h13v2H4zM10 6h7v2h-7zM10 12h7v2h-7zM10 9h7v2h-7z\" ></path><g ><path d=\"M4.1 12.9c-.3 0-.6-.1-.8-.4-.3-.5-.2-1.1.2-1.4l1.6-1.2-1.6-1.2c-.4-.3-.5-1-.2-1.4.3-.4 1-.5 1.4-.2l3.8 2.8-3.8 2.8c-.1.1-.4.2-.6.2z\" ></path></g>'
    },
    textIndentRight: {
        svg: {
            width: '20',
            height: '22',
            viewBox: '0 0 20 22'
        },
        content: '<path d=\"M3 3h13v2H3zM3 15h13v2H3zM3 6h7v2H3zM3 12h7v2H3zM3 9h7v2H3z\" ></path><g ><path d=\"M16 12.9c.3 0 .6-.1.8-.4.3-.4.2-1.1-.2-1.4L15 9.9l1.6-1.2c.4-.3.5-1 .2-1.4-.3-.4-1-.5-1.4-.2l-3.8 2.8 3.8 2.8c.2.1.4.2.6.2z\" ></path></g>'
    },
    textItalic: {
        svg: {
            width: '8',
            height: '14',
            viewBox: '0 0 8 14'
        },
        content: '<path fill-rule=\"evenodd\" d=\"M8 2V0H1v2h2.71L2.12 12H0v2h7v-2H4.15L5.74 2H8z\" ></path>'
    },
    textLineHeight: {
        svg: {
            width: '18',
            height: '14',
            viewBox: '0 0 18 14'
        },
        content: '<path fill-rule=\"evenodd\" d=\"M7.5 14v-2h10v2h-10zm0-6h10v2h-10V8zm0-4h10v2h-10V4zm0-4h10v2h-10V0zm-2 10l-3 4-3-4h2V4h-2l3-4 3 4h-2v6h2z\" ></path>'
    },
    textLink: {
        svg: {
            width: '18',
            height: '17',
            viewBox: '0 0 18 17'
        },
        content: '<path fill-rule=\"evenodd\" d=\"M16.32 7l-3.43 3.42a3.976 3.976 0 0 1-5.63 0 .96.96 0 0 1 0-1.38.96.96 0 0 1 1.38 0c.77.76 2.1.76 2.87 0l3.42-3.43c.38-.38.6-.89.6-1.43 0-.54-.22-1.05-.6-1.44a2.04 2.04 0 0 0-2.86 0l-1.7 1.71a.99.99 0 0 1-1.39 0 .99.99 0 0 1 0-1.39l1.7-1.7a4.002 4.002 0 0 1 5.64 0c1.55 1.55 1.55 4.08 0 5.64zm-5.26 1c-.38.39-1 .39-1.39 0-.79-.79-2.07-.79-2.86 0l-3.43 3.43c-.38.38-.59.89-.59 1.43 0 .54.21 1.05.59 1.44.79.78 2.08.78 2.87 0l1.7-1.71c.38-.38 1-.38 1.38 0 .39.39.39 1.01 0 1.39l-1.7 1.7a3.976 3.976 0 0 1-5.63 0 3.964 3.964 0 0 1-1.17-2.82c0-1.06.42-2.06 1.17-2.82l3.42-3.42a3.983 3.983 0 0 1 5.64 0c.38.38.38 1 0 1.38z\" ></path>'
    },
    textListBullets: {
        svg: {
            width: '20',
            height: '22',
            viewBox: '0 0 20 22'
        },
        content: '<path d=\"M7 15h10v2H7zM7 9h10v2H7zM7 3h10v2H7zM2 2h3v3H2zM2 8h3v3H2zM2 14h3v3H2z\" ></path>'
    },
    textListBulletsRight: {
        svg: {
            width: '20',
            height: '22',
            viewBox: '0 0 20 22'
        },
        content: '<path d=\"M5 15h10v2H5zM5 9h10v2H5zM5 3h10v2H5zM17 2h3v3h-3zM17 8h3v3h-3zM17 14h3v3h-3z\" ></path>'
    },
    textListNone: {
        svg: {
            width: '20',
            height: '20',
            viewBox: '0 0 20 20'
        },
        content: '<rect width=\"20\" height=\"20\" fill=\"#FFF\" rx=\"6\" ></rect><path fill=\"#ee5951\" fill-rule=\"evenodd\" d=\"M3.57 17.99L18.42 3.15 17.26 2 2.42 16.84l1.15 1.15z\" ></path><path fill=\"#d8e1e8\" fill-rule=\"evenodd\" d=\"M14 19c2.76 0 5-2.24 5-5V6c0-2.76-2.24-5-5-5H6C3.24 1 1 3.24 1 6v8c0 2.76 2.24 5 5 5h8m0 1H6c-3.31 0-6-2.69-6-6V6c0-3.31 2.69-6 6-6h8c3.31 0 6 2.69 6 6v8c0 3.31-2.69 6-6 6z\" ></path>'
    },
    textListNumbers: {
        svg: {
            width: '20',
            height: '22',
            viewBox: '0 0 20 22'
        },
        content: '<path d=\"M8 15h10v2H8zM8 9h10v2H8zM8 3h10v2H8zM3 2v1h1v3h1V2zM6 12H3.6v-1l2-2H3V8h3v1l-1.4 2H6v1zM5.8 17l-1.2-1 1.2-1H3v-1h3v1l-1.2 1L6 17v1H3v-1h2.8z\" ></path>'
    },
    textListNumbersRight: {
        svg: {
            width: '20',
            height: '22',
            viewBox: '0 0 20 22'
        },
        content: '<path d=\"M3 15h10v2H3zM3 9h10v2H3zM3 3h10v2H3zM15 2v1h1v3h1V2zM18 12h-2.4v-1l2-2H15V8h3v1l-1.4 2H18v1zM17.8 17l-1.2-1 1.2-1H15v-1h3v1l-1.2 1 1.2 1v1h-3v-1h2.8z\" ></path>'
    },
    textOutdentLeft: {
        svg: {
            width: '20',
            height: '22',
            viewBox: '0 0 20 22'
        },
        content: '<path d=\"M4 3h13v2H4zM4 15h13v2H4zM10 6h7v2h-7zM10 12h7v2h-7zM10 9h7v2h-7z\" ></path><g ><path d=\"M7.1 12.9c-.2 0-.4-.1-.6-.2L2.7 9.9l3.8-2.8c.5-.4 1.1-.3 1.4.2.3.4.2 1.1-.2 1.4L6.1 9.9l1.6 1.2c.4.3.5 1 .2 1.4-.1.2-.5.4-.8.4z\" ></path></g>'
    },
    textOutdentRight: {
        svg: {
            width: '20',
            height: '22',
            viewBox: '0 0 20 22'
        },
        content: '<path d=\"M2 3h13v2H2zM2 15h13v2H2zM2 6h7v2H2zM2 12h7v2H2zM2 9h7v2H2z\" ></path><g ><path d=\"M13.1 12.9c.2 0 .4-.1.6-.2l3.8-2.8-3.8-2.8c-.4-.3-1.1-.2-1.4.2-.3.4-.3 1.1.2 1.4l1.6 1.2-1.6 1.2c-.4.3-.5 1-.2 1.4.2.2.5.4.8.4z\" ></path></g>'
    },
    textRemoveFormat: {
        svg: {
            width: '19',
            height: '15',
            viewBox: '0 0 19 15'
        },
        content: '<path fill-rule=\"evenodd\" d=\"M18.2 13.44l-1.42 1.41-1.79-1.79-1.79 1.79-1.42-1.41 1.8-1.79-1.8-1.8 1.42-1.41 1.79 1.79 1.79-1.79 1.42 1.41-1.8 1.8 1.8 1.79zM12.02 3.01c0-.55-.37-.99-.92-.99H8.02v10h2v2h-6v-2h2v-10H3.1c-.55 0-1.08.44-1.08.99v3.01h-2V3.01C.02 1.36 1.45.02 3.1.02h8c1.65 0 2.92 1.34 2.92 2.99v3.01h-2V3.01z\" ></path>'
    },
    textUnderline: {
        svg: {
            width: '12',
            height: '16',
            viewBox: '0 0 12 16'
        },
        content: '<path fill-rule=\"evenodd\" d=\"M0 16v-2h12v2H0zm6-3.75c-2.8 0-5-2.24-5-5.21V1.09C1 .49 1.4 0 2 0s1 .49 1 1.09v5.95c0 1.5 1.21 3.03 3 3.03s3-1.53 3-3.03V1.09C9 .49 9.4 0 10 0s1 .49 1 1.09v5.95c0 2.97-2.2 5.21-5 5.21z\" ></path>'
    },
    textUnlink: {
        svg: {
            width: '22',
            height: '18',
            viewBox: '0 0 22 18'
        },
        content: '<g fill=\"none\" fill-rule=\"evenodd\" ><path fill=\"#2B5672\" d=\"M7.862 12.981l-1.646 1.67c-.799.81-2.1.81-2.899 0-.8-.81-.8-2.13-.001-2.94l3.317-3.363c.8-.81 2.101-.81 2.9 0a.85.85 0 0 0 1.216 0 .879.879 0 0 0-.001-1.231 3.737 3.737 0 0 0-5.329 0l-3.318 3.362a3.864 3.864 0 0 0 .001 5.404 3.734 3.734 0 0 0 5.329 0l1.646-1.67a.879.879 0 0 0 0-1.232.851.851 0 0 0-1.215 0z\" ></path><path fill=\"#2B5672\" d=\"M15.897 2.085c-1.423-1.447-3.908-1.447-5.328 0L8.923 3.76a.884.884 0 0 0 0 1.235.846.846 0 0 0 1.213 0l1.647-1.673c.774-.789 2.123-.789 2.9 0 .386.393.6.917.6 1.473 0 .557-.214 1.081-.601 1.476l-3.316 3.373c-.8.814-2.101.813-2.9 0a.847.847 0 0 0-1.215 0 .885.885 0 0 0 0 1.237c.735.746 1.7 1.119 2.665 1.119.966 0 1.93-.373 2.665-1.12l3.315-3.374A3.84 3.84 0 0 0 17 4.796a3.842 3.842 0 0 0-1.103-2.71z\" ></path><path fill=\"#EE5951\" d=\"M19.265 14l1.473-1.473a.895.895 0 0 0-1.265-1.264L18 12.736l-1.473-1.474a.893.893 0 1 0-1.265 1.265l1.473 1.474-1.473 1.472a.895.895 0 0 0 1.265 1.264L18 15.266l1.473 1.473a.89.89 0 0 0 1.265 0 .895.895 0 0 0 0-1.265L19.265 14z\" ></path></g>'
    },
    textUploadFonts: {
        svg: {
            width: '19',
            height: '19',
            viewBox: '0 0 19 19'
        },
        content: '<g fill-rule=\"evenodd\" ><path d=\"M9 4.5V14h1V4.5L12.5 7l.5-.625L9.5 3 6 6.375 6.5 7 9 4.5z\" ></path><path d=\"M16 14.5c0 .827-.673 1.5-1.5 1.5h-10c-.827 0-1.5-.673-1.5-1.5V9H2v5.5C2 15.878 3.122 17 4.5 17h10c1.378 0 2.5-1.122 2.5-2.5V9h-1v5.5z\" ></path></g>'
    },
    textWriteDirectionLeft: {
        svg: {
            width: '12',
            height: '14',
            viewBox: '0 0 12 14'
        },
        content: '<path fill-rule=\"evenodd\" d=\"M10 13.5v-14h2v14h-2zm-3-8H5.7c-1.82 0-3.3-1.18-3.3-3s1.48-3 3.3-3H9v14H7v-8zm-5.39 7.79c-.18.14-.4.21-.61.21a1 1 0 0 1-.79-.39.99.99 0 0 1 .18-1.4l1.58-1.21L.39 9.29a.99.99 0 0 1-.18-1.4 1 1 0 0 1 1.4-.18l3.66 2.79-3.66 2.79z\" ></path>'
    },
    textWriteDirectionRight: {
        svg: {
            width: '18',
            height: '14',
            viewBox: '0 0 18 14'
        },
        content: '<path fill-rule=\"evenodd\" d=\"M15.79 11l1.6 1.21c.44.33.53.96.19 1.4-.2.25-.5.39-.81.39-.21 0-.43-.07-.61-.21L12.44 11l3.72-2.79c.44-.34 1.08-.25 1.42.18.34.44.25 1.07-.19 1.4L15.79 11zM8.65 0h2.03v14H8.65V0zM5.61 6H4.29C2.44 6 .95 4.82.95 3s1.49-3 3.34-3H7.64v14H5.61V6z\" ></path>'
    },
    textDesign: {
        svg: {
            width: '14',
            height: '13',
            viewBox: '0 0 14 13'
        },
        content: '<path fill-rule=\"evenodd\" d=\"M10.5-.5h-8c-1.65 0-3 1.35-3 3v2h2v-2c0-.55.45-1 1-1h3v9h-2v2h6v-2h-2v-9h3c.55 0 1 .45 1 1v2h2v-2c0-1.65-1.35-3-3-3z\" ></path>'
    },
    noLink: {
        svg: {
            width: '173',
            height: '70',
            viewBox: '0 0 173 70'
        },
        content: '<path d=\"M105 29a2 2 0 0 0-2-2H88a2 2 0 1 0 0 4h15a2 2 0 0 0 2-2M105 16.612a2 2 0 0 0-2-2H88a2 2 0 1 0 0 4h15a2 2 0 0 0 2-2\" class=\"plug-pin\" ></path><path d=\"M128 23.47c4.304 0 7-4.6 7-8.904V8.545c0-4.304 3.196-7.794 7.5-7.794s7.5 3.49 7.5 7.794v8.443c0 3.382 3.653 7.624 7.035 7.624H172m-129-.807c-4.304 0-8 3.651-8 7.955v6.021c0 4.304-3.196 7.794-7.5 7.794s-7.5-3.49-7.5-7.794v-8.443c0-3.382-1.153-5.726-4.535-5.726H0\" class=\"wires\" ></path><path d=\"M100 6h6v33h-6V6z\" class=\"plug-strip\" ></path><path d=\"M106 10v25h8.5c2.761 0 4.5-2.776 4.5-5.537v-15c0-2.762-1.739-4.463-4.5-4.463H106\" class=\"plug-body\" ></path><path d=\"M118 16h11v13h-11V16z\" class=\"plug-body\" ></path><path d=\"M123.5 20a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5\" class=\"white\" ></path><path d=\"M65 6h6v33h-6V6z\" class=\"plug-strip\" ></path><path d=\"M65 35V10h-7.5c-2.761 0-5.5 1.701-5.5 4.463v15C52 32.224 54.739 35 57.5 35H65\" class=\"plug-body\" ></path><path d=\"M42 16h11v13H42V16z\" class=\"plug-body\" ></path><path d=\"M47.5 25a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5\" class=\"white\" ></path><path d=\"M123.996 67c0 1.104-6.044 2-13.5 2s-13.5-.896-13.5-2c0-1.105 6.044-2 13.5-2s13.5.895 13.5 2M70.996 67c0 1.104-6.044 2-13.5 2s-13.5-.896-13.5-2c0-1.105 6.044-2 13.5-2s13.5.895 13.5 2\" class=\"plug-shadow\" ></path>'
    },
    arrowDown: {
        svg: {
            width: '12',
            height: '12',
            viewBox: '135.1 -517.4 1024 1024'
        },
        content: '<path d=\"M137.3-195c0 17.4 7.4 34.7 19.8 47.1l441.4 409.1c27.3 24.8 71.9 24.8 99.2 0l438.9-429c27.3-24.8 27.3-66.9 0-91.7-27.3-24.8-71.9-24.8-99.2 0L648.1 122.3 256.3-242.2c-27.3-24.8-71.9-24.8-99.2 0-12.4 14.9-19.8 29.8-19.8 47.2z\" class=\"c1\" ></path>'
    }
}



// WEBPACK FOOTER //
// ./src/components/toolbar/symbols.js